/* eslint-disable no-mixed-operators */
import * as React from 'react';
import { Dropdown, IDropdownOption } from '@fluentui/react/lib/Dropdown';
import { CheckboxVisibility, ConstrainMode, IColumn, SelectionMode, Selection } from '@fluentui/react/lib/DetailsList';
import { connect } from 'react-redux';
import _ from 'lodash';
import { IUserProfile } from '../../../Auth/types';
import { confirmDialog, showDialog, showToastMessage } from '../../../Dialog/actions';
import Helper from '../../../../core/libraries/Helper';
import RbLabel, { LabelSize } from '../../../../bosch-react/components/label/RbLabel';
import { getDivisionsList } from '../../../../services/commonServices';
import { IDivision } from '../Division/types';
import RbButton, { ButtonSize, ButtonType } from '../../../../bosch-react/components/button/RbButton';
import { FontWeights, Icon, IconButton, IListProps, mergeStyleSets, Panel, PanelType, ShimmeredDetailsList, TooltipHost } from '@fluentui/react';
import DetailsListWrapper from '../../../../core/components/DetailsListWrapper/DetailsListWrapper';
import Configuration from '../../../../core/libraries/Configuration';
import { RootState } from '../../../../store/store';
import { retrieveAIMHistory, sendAIMReport, validateDepartments } from '../../services';
import { IAIMHistory, IValidation } from './types';
import Color from '../../../../core/libraries/Color';
import Constants from '../../../../core/libraries/Constants';
import Template from '../../../../core/libraries/Template';
import { addAliasDomain } from '../../../../utils/converter';
import { tooltipHostStyles } from '../types';


interface AIMReportProps {
    userProfile: IUserProfile | undefined,
    confirmDialog: typeof confirmDialog,
    showDialog: typeof showDialog,
    showToastMessage: typeof showToastMessage
}

interface IState {
    selectedDivision: string | null,
    divisions: IDropdownOption[] | null,
    items: IValidation[] | null,
    selectedItems: IValidation[] | null,
    selectedItem: IValidation | null,
    isShowPanel: boolean,
    invalidItems: IValidation[] | null,
    selectedAIMHistoryList: IAIMHistory[] | null,
}

class AIMReport extends React.Component<AIMReportProps, IState> {


    constructor(props: AIMReportProps) {
        super(props);

        this.state = {
            selectedDivision: null,
            divisions: [],
            items: [],
            selectedItems: [],
            isShowPanel: false,
            selectedItem: null,
            invalidItems: [],
            selectedAIMHistoryList: null
        };
        this.renderDivision = this.renderDivision.bind(this);
    }

    async componentDidMount() {
        const cachedItems = sessionStorage.getItem(Constants.SESSION_STORAGE_KEYS.aimReportState);
        if (!!cachedItems) {
            // If cached data exists, use it
            this.setState({ ...JSON.parse(cachedItems) });
        }
        else {
            let response = await getDivisionsList();
            let divisions: IDivision[] = !!(response.data) && response.data;
            let rs: IDropdownOption[] = [];
            divisions.forEach((division) => {
                rs.push({
                    key: division.title || "",
                    text: division.longTitle || "",
                });
            });
            rs.unshift({ key: "All", text: "--- All ---" });
            this.setState({ divisions: rs });
        }
    }

    // Handle selection changes
    onSelectionChanged = () => {
        const selectedItems = this.selection.getSelection() as IValidation[]; // Get selected items
        const invalidItems = selectedItems.filter(item => !item.departmentHead)
        this.setState({ selectedItems });
        this.setState({ invalidItems });
    };

    selection = new Selection({
        onSelectionChanged: this.onSelectionChanged // Callback when selection changes
    });

    styles = mergeStyleSets({
        buttonArea: {
            verticalAlign: 'top',
            display: 'inline-block',
            textAlign: 'center',
            margin: '0 100px',
            minWidth: 130,
            height: 32,
        },
        configArea: {
            width: 300,
            display: 'inline-block',
        },
        button: {
            width: 130,
        },
        callout: {
            width: 320,
            padding: '20px 24px',
        },
        title: {
            marginBottom: 12,
            fontWeight: FontWeights.semilight,
        },
        link: {
            display: 'block',
            marginTop: 20,
        },
    });



    columns: IColumn[] = [
        {
            key: 'departmentName', name: 'Department Name', fieldName: 'DepartmentName',
            currentWidth: Helper.resizeColumnByScreenWidth(30),
            minWidth: Helper.resizeColumnByScreenWidth(30),
            isResizable: true,
            onRender: (item: IValidation) => {
                return (<RbLabel size={LabelSize.Small}>{item.departmentName}</RbLabel>);
            }
        },
        {
            key: 'hod', name: 'Head of Department', fieldName: 'HoD',
            currentWidth: Helper.resizeColumnByScreenWidth(30),
            minWidth: Helper.resizeColumnByScreenWidth(30),
            isResizable: true,
            onRender: (item: IValidation) => {
                return (
                    !!item.departmentHead && <RbLabel size={LabelSize.Small}>{item.departmentHead}</RbLabel> ||
                    <Icon
                        iconName="Clear"
                        style={{ color: Color.RED }}
                    />
                );
            }
        },
        {
            key: 'action', name: 'Action', fieldName: 'Action',
            currentWidth: Helper.resizeColumnByScreenWidth(40),
            minWidth: Helper.resizeColumnByScreenWidth(40),
            isResizable: true,
            onRender: (item: IValidation) => {
                return (<>
                    <RbButton disabled={!item.departmentHead} type={ButtonType.Primary} size={ButtonSize.Tiny} label='Send' onClick={() => {
                        this.setState({
                            selectedItem: item
                        }, async () => {
                            await this.handleSendAIMReport(false);
                        })
                    }} />
                    <RbButton type={ButtonType.Secondary} size={ButtonSize.Tiny} label='View last sent' onClick={() => {
                        this.setState({
                            isShowPanel: true,
                            selectedItem: item
                        }, async () => {
                            await this.handleViewLastSent()
                        })
                    }} />
                </>
                );
            }
        }
    ]

    aimHistoryColumns: IColumn[] = [
        {
            key: 'HoD', name: 'HoD', fieldName: 'HoD',
            currentWidth: Helper.resizeColumnByScreenWidth(12),
            minWidth: Helper.resizeColumnByScreenWidth(12),
            isResizable: true,
            onRender: (item: IAIMHistory) => {
                return (Template.renderReadOnlyPeople([item.hoDid], "", true));
            }
        },
        {
            key: 'sentAt', name: 'Sent At', fieldName: 'Sent At',
            currentWidth: Helper.resizeColumnByScreenWidth(10),
            minWidth: Helper.resizeColumnByScreenWidth(10),
            isResizable: true,
            onRender: (item: IAIMHistory) => {
                return (<RbLabel size={LabelSize.Small}>{Helper.getDateTimeFormatForUI(item.created)}</RbLabel>);

            }
        },
        {
            key: 'sender', name: 'Sender', fieldName: 'Sender',
            currentWidth: Helper.resizeColumnByScreenWidth(12),
            minWidth: Helper.resizeColumnByScreenWidth(12),
            isResizable: true,
            onRender: (item: IAIMHistory) => {
                return (Template.renderReadOnlyPeople([item.createdBy], "", true));
            }
        }
    ]

    shimmeredDetailsListProps: IListProps = {
        renderedWindowsAhead: 0,
        renderedWindowsBehind: 0,
    };

    _onDismissPanel = () => {
        this.setState({ isShowPanel: false })
    }

    handleViewLastSent = async () => {
        const { selectedItem } = this.state
        const aimHistoryList = !!selectedItem && !!selectedItem.departmentName && await retrieveAIMHistory(selectedItem.departmentName);
        !!aimHistoryList && aimHistoryList.length > 0 && this.setState({
            selectedAIMHistoryList: aimHistoryList
        })
    }

    async handleSendAIMReport(isMultiSelection: boolean) {
        this.props.showDialog("Sending...");
        const { selectedItems, selectedItem } = this.state
        const departments = !!isMultiSelection && !!selectedItems && selectedItems?.length > 0 && selectedItems.map(item => item.departmentName) || !!selectedItem && [selectedItem.departmentName] || []
        const success = departments.length > 0 && await sendAIMReport(departments)
        this.props.showDialog(false);
        this.props.showToastMessage(!!success && 'success' || 'error', `Send AIM report ${!!success && 'success' || 'failed'}`);
    }

    render() {
        const { items, invalidItems, selectedAIMHistoryList, selectedItems } = this.state
        const checkIsInvalid = !!invalidItems && invalidItems.length > 0
        let element = (
            <div className="ms-Grid">
                <div className="ms-Grid-row common-padding-row">
                    {this.renderDivision()}
                    {/* Button "Send" */}
                    <div className="ms-Grid-col ms-sm7" style={{ paddingTop: "5px" }}>
                        <RbButton disabled={checkIsInvalid || !selectedItems || selectedItems.length === 0} label="Send selected rows" size={ButtonSize.Small} onClick={() => { this.handleSendAIMReport(true) }} />
                        {checkIsInvalid && <RbLabel style={{ color: Color.RED }}>{invalidItems.map(item => item.departmentName).join(', ')} not valid to send</RbLabel>}
                        <TooltipHost
                            content={"The AIM reports are sent out to all HoDs to check the access permissions for all the reports from their department. If anything is wrong, they could send feedback to the Product Owner to help to edit the permission."}
                            styles={tooltipHostStyles}
                            calloutProps={{ gapSpace: 10 }}
                        >
                            <IconButton
                                iconProps={{ iconName: "Info" }}
                                ariaLabel="Tab information"
                                title="Tab information"
                            />
                        </TooltipHost>
                    </div>
                </div>
                <DetailsListWrapper>
                    <ShimmeredDetailsList
                        setKey="set"
                        compact={true}
                        items={items || []}
                        constrainMode={ConstrainMode.unconstrained}
                        columns={this.columns}
                        enableShimmer={!items}
                        selection={this.selection}
                        selectionMode={SelectionMode.multiple}
                        checkboxVisibility={CheckboxVisibility.always}
                        ariaLabelForShimmer="Content is being fetched"
                        ariaLabelForGrid="Pending order details"
                        listProps={this.shimmeredDetailsListProps}
                        onRenderDetailsHeader={Configuration.onRenderStickyDetailsHeader}
                        onShouldVirtualize={() => { return true }}
                    />
                </DetailsListWrapper>
                <Panel
                    headerText={`AIM history of the ${this.state.selectedItem?.departmentName}`}
                    isBlocking={false}
                    isOpen={this.state.isShowPanel}
                    onDismiss={this._onDismissPanel}
                    closeButtonAriaLabel="Close"
                    isFooterAtBottom={true}
                    type={PanelType.medium}
                >
                    <br />
                    <br />
                    <DetailsListWrapper>
                        <ShimmeredDetailsList
                            setKey="set"
                            compact={true}
                            items={selectedAIMHistoryList || []}
                            constrainMode={ConstrainMode.unconstrained}
                            columns={this.aimHistoryColumns}
                            enableShimmer={!selectedAIMHistoryList}
                            selectionMode={SelectionMode.none}
                            checkboxVisibility={CheckboxVisibility.always}
                            ariaLabelForShimmer="Content is being fetched"
                            ariaLabelForGrid="Pending order details"
                            listProps={this.shimmeredDetailsListProps}
                            onRenderDetailsHeader={Configuration.onRenderStickyDetailsHeader}
                            onShouldVirtualize={() => { return true }}
                        />
                    </DetailsListWrapper>
                </Panel>
            </div>
        );
        return element;
    }

    renderAIMHistory = () => {
        const { selectedAIMHistoryList } = this.state
        return !!selectedAIMHistoryList && selectedAIMHistoryList.length > 0 && selectedAIMHistoryList.map((element, index) => {
            return <>
                <div>Last sent at {Helper.getDateTimeFormatForUI(element.created)} to {Template.renderPeopleTextInlineTemplate([element.hoDid])} by {Template.renderPeopleTextInlineTemplate([element.createdBy])}</div>
                <br />
            </>
        });
    }

    renderDivision() {
        return this.renderRetrieveTemplate("Division",
            <Dropdown
                selectedKey={this.state.selectedDivision}
                placeholder="Choose a division ..."
                options={this.state.divisions || []}
                onChange={(event, option) => {
                    !!option && !!option.key && this.setState({ selectedDivision: option.key.toString() }, async () => {
                        await this.handleValidatingDepartment(this.state.selectedDivision!)
                    })
                }}
            />);
    }

    renderRetrieveTemplate(label: string, field: any) {
        return (
            <div className="ms-Grid-col ms-sm5">
                <div className="ms-Grid">
                    <div className="ms-Grid-row common-padding-row">
                        <div className="ms-Grid-col ms-sm4"><RbLabel hasPadding={true}>{label}</RbLabel></div>
                        <div className="ms-Grid-col ms-sm8">
                            {field}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    handleValidatingDepartment = async (div: string) => {
        this.props.showDialog("Validating departments...")
        const items = await validateDepartments(div, true) || []
        items.length > 0 && this.setState({
            items: items
        }, () => {
            sessionStorage.setItem(Constants.SESSION_STORAGE_KEYS.aimReportState, JSON.stringify(this.state)); // Cache data in localStorage
        })
        this.props.showDialog(false)
    }
}

const mapStateToProps = (state: RootState) => ({
    userProfile: state.auth.userProfile
});

export default connect(mapStateToProps, { confirmDialog, showDialog, showToastMessage })(AIMReport);